/* eslint-disable */
import React, { useMemo, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import { CTitle, STitle } from '../../components/Widget';
import ImgPoint from '../../../../../../assets/cybersecurity2026/finger.gif';
import { useUpdateComponentState } from '../../../hooks';
interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const [state, setState] = useState({
    play: 1,
    factorPlay: 1,
    isFactorPlayed: false,
  });
  // 添加状态控制显示的项目数量，默认只显示第一条
  const [visibleItems, setVisibleItems] = useState(1);
  const updateComponentState = useUpdateComponentState();

  const startFactorPlay = (next = 1) => {
    if (state.isFactorPlayed) {
      return;
    }
    next += 1;
    setState({ ...state, factorPlay: next, isFactorPlayed: true });
    if (next <= 4) {
      setTimeout(() => startFactorPlay(next), 500);
    } else {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1230pm-section1-2'
      );
    }
  };

  // 点击第一条时逐步展示所有项目
  const handleFirstItemClick = () => {
    if (paragraphsSettings.l1List && visibleItems === 1) {
      let count = 1;
      const totalItems = paragraphsSettings.l1List.length;
      const interval = setInterval(() => {
        count++;
        setVisibleItems(count);
        if (count >= totalItems) {
          clearInterval(interval);
          updateComponentState(
            p_course,
            p_topic,
            ID,
            'cybersecurity2026-topic1230pm-section1-1'
          );
        }
      }, 500);
    }
  };
  return (
    <div className="topic-section-1">
      <CTitle title={paragraphsSettings?.title} />
      <div className="phishing-fraud">
        <div className="phishing-fraud-text">
          <div className="question-con">{paragraphsSettings.l1Tip}</div>
        </div>
        {visibleItems === 1 && (
          <img src={ImgPoint} alt="" className="img-point" />
        )}
        <div
          className="phishing-fraud-list"
          id="cybersecurity2026-topic1230pm-section1-1"
        >
          {paragraphsSettings.l1List?.map((item: any, index: number) => (
            <div
              className={`phishing-fraud-item ${
                index < visibleItems ? 'visible' : ''
              }`}
              key={index}
              onClick={() => {
                if (index === 0) {
                  handleFirstItemClick();
                }
              }}
              style={{
                cursor:
                  index === 0 && visibleItems === 1 ? 'pointer' : 'default',
              }}
            >
              <div className="title-style">{item.title}</div>
              <div className="con-style">{item.content}</div>
            </div>
          ))}
        </div>
      </div>
      <div
        className="factor-content"
        id="cybersecurity2026-topic1230pm-section1-2"
        onClick={() => startFactorPlay()}
      >
        <div className="triangle-container">
          <span className="triangle"></span> {paragraphsSettings.tips}
        </div>
        {state.factorPlay <= 1 && (
          <img src={ImgPoint} alt="" className="img-point" />
        )}
        <div className="factor-tips">{paragraphsSettings?.l4Tip}</div>
        {paragraphsSettings?.l4?.map((item: string, i: number) => (
          <div
            className={`factor-item factor-item-${i + 1} ${
              state.factorPlay > i ? 'box-fade-right-in' : ''
            }`}
            key={i}
          >
            <span>{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Section1;
